import React, {Component} from 'react'
import { observer } from 'mobx-react'
import liqpayGeneratorStore from "../../store/LiqpayGeneratorStore";

@observer
class LiqpayOverlay extends Component {
    render() {
        return (
            <div className={liqpayGeneratorStore.callbackState === 'none' ? 'overlay' : `overlay show ${liqpayGeneratorStore.callbackState}`} >
                <div className='loading-box' >
                    <img src='/assets/img/progress.svg' />
                </div>
                <div className='error-box' >
                    {liqpayGeneratorStore.errorText}
                </div>
            </div>
        )
    }
}

export default LiqpayOverlay
